
















































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { InstituteInfo } from "../../_models/instituteInfo";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";
import GiorniDialog from "../Dialogs/GiorniDialog.vue";
import TurniDialog from "../Dialogs/TurniDialog.vue";
import { UserInfo } from "../../_models/userInfo";
import LinkWorkshopDialog from "../Dialogs/LinkWorkshopDialog.vue";
import DownloadRecords from "../DownloadRecords.vue";

@Component({
  components: {
    GiorniDialog,
    TurniDialog,
    LinkWorkshopDialog,
    DownloadRecords
  }
})
export default class ScheduleDataTable extends Vue {
  @Prop() params!: any;
  @Prop() createDialogParams!: object;
  @Prop() listaGiorni!: any;
  @Prop() listaTurni!: any;
  @Prop() userInfo!: UserInfo;
  @Prop() recordType!: any;
  private loadingData: boolean;
  private search: string;

  //private userInfo: any;

  // private listaGiorni: any;
  // private listaTurni: any;

  private articolazioni: any;
  private articolazioneFilter: string;
  private giorni: any;
  private giorniFilter: string;

  private filters: any;

  constructor() {
    super();
    this.loadingData = false;
    this.search = "";
    this.articolazioni = this.params.listaArticolazioni;
    this.articolazioneFilter = "Tutte";
    this.giorni = this.params.listaGiorni;
    this.giorniFilter = "Tutti";

    this.filters = {
      fitroArticolazione: "",
      filtroGiorno: ""
    };

    // this.listaGiorni = [];
    // this.listaTurni = [];
  }

  @Watch("articolazioneFilter")
  onArticolazioneChange(value: string) {
    this.filterChange();
    // bus.$emit("autorizzazioneFilter", value)
  }

  @Watch("giorniFilter")
  onGiornoChange(value: string) {
    this.filterChange();
    // bus.$emit("autorizzazioneFilter", value)
  }

  filterChange() {
    // var filters = {
    //   fitroArticolazione: ""
    // };
    // if (this.params.filterType === "listaOfferteAllievo") {
    this.filters = {
      fitroArticolazione: this.articolazioneFilter,
      filtroGiorno: this.giorniFilter
    };
    bus.$emit("filtroIscrizioniWorkshop", this.filters);
    // }
  }

  changeStatusPresenzaWorkshop(
    idInformazioneWorkshop: number,
    presenzaWorkshop: boolean
  ) {
    // if (presenzaWorkshop === false) {
    //   presenzaWorkshop = true;
    // } else {
    //   presenzaWorkshop = false;
    // }
    var payload = {
      idInformazioneWorkshop: idInformazioneWorkshop,
      presenzaWorkshop: presenzaWorkshop
    };
    user
      .dispatchChangeStatusPresenzaWorkshop(this["$store"], payload)
      .then(() => {
        //this.loadCandidature();
        //bus.$emit("loadSchedulazioneWorkshop", this.filters);
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  changed() {
    bus.$emit("scheduleChanged");
  }

  deleteScheduleWorkshop(idSchedule: number) {
    var payload = {
      idInformazioneWorkshop: idSchedule
    };
    user
      .dispatchDeleteScheduleWorkshop(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Schedulazione cancellata con successo"
        );
        bus.$emit("loadSchedulazioneWorkshop");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  // loadGiorniWorkshop() {
  //   var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
  //   var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
  //   var payload = {
  //     idIstituto: instituteInfo.id,
  //     idAnnoScolastico: idAnnoScolastico
  //   };
  //   data.dispatchGiorniWorkshop(this["$store"], payload).then(result => {
  //     this.listaGiorni = result
  //     console.log(this.listaGiorni)
  //   });
  // }

  created() {
    // this.userInfo = user.readUserInfo(this["$store"]);

    bus.$on("dataLoadedSchedule", () => {
      this.loadingData = false;
    });

    bus.$on("saveSchedule", () => {
      this.articolazioneFilter = "Tutte";
    });
  }
}
